import { NgIf } from '@angular/common';
import {
  Component,
  DestroyRef,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { BehaviorSubject } from 'rxjs';

import { CanDeactivateHelperService } from '../../core/services/can-deactivate-helper.service';
import { UploadResourceService } from './upload-resource.service';
import { UploadResourceProgressComponent } from './upload-resource-progress/upload-resource-progress.component';

@Component({
  imports: [UploadResourceProgressComponent, NgIf],
  selector: 'tdv-upload-resource-wrap',
  providers: [CanDeactivateHelperService],
  templateUrl: './upload-resource-wrap.component.html',
  styleUrls: ['./upload-resource-wrap.component.scss'],
})
export class UploadResourceWrapComponent implements OnInit, OnDestroy {
  readonly canDeactivateHelperS = inject(CanDeactivateHelperService);
  private readonly destroyRef = inject(DestroyRef);

  public showProgress = false;
  private timeout?: NodeJS.Timeout;

  isCanBeDeactivatedBehaviourSubject = new BehaviorSubject<boolean>(true);

  constructor(private uploadResourceS: UploadResourceService) {}

  ngOnInit(): void {
    this.initPreventCloseBrowserIfLoadProgress();
    this.initProgressVisibility();
    this.canDeactivateHelperS.initBeforeUnloadEvent(
      this.isCanBeDeactivatedBehaviourSubject,
      this.destroyRef,
    );
  }

  ngOnDestroy(): void {
    this.isCanBeDeactivatedBehaviourSubject.next(true);
  }

  private initProgressVisibility(): void {
    this.uploadResourceS
      .selectUploadItems()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(uploads => {
        if (uploads.length === 0) {
          if (this.showProgress) {
            this.closeWithDelay();
          }
        } else {
          if (this.timeout) {
            clearTimeout(this.timeout);
          }
          this.showProgress = true;
        }
      });
  }

  private closeWithDelay(): void {
    this.timeout = setTimeout(() => {
      this.showProgress = false;
      this.isCanBeDeactivatedBehaviourSubject.next(true);
    }, this.uploadResourceS.hideDelayMs);
  }

  private initPreventCloseBrowserIfLoadProgress(): void {
    this.uploadResourceS
      .selectUploadItems()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(list => {
        const isUploadInProgress =
          list.filter(
            i =>
              !i.isCancelled &&
              i.progressForUploadBlobWatcher.value !== 100 &&
              !i.errorWatcher.value,
          ).length > 0;
        this.isCanBeDeactivatedBehaviourSubject.next(!isUploadInProgress);
      });
  }
}
